import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  num: '1',
  title: 'Las Vocales Divertidas',
  subtitle: 'Reconocimiento visual y auditivo de cada vocal mediante actividades simples.'
}, {
  num: '2',
  title: 'El Mundo de las Sílabas',
  subtitle: 'MA-ME-MI-MO-MU · PA-PE-PI-PO-PU · LA-LE-LI-LO-LU · SA-SE-SI-SO-SU.'
}, {
  num: '3',
  title: 'Mis Primeras Palabras',
  subtitle: 'MAMÁ, PAPÁ, PATO, MANO, MESA, LUNA.'
}, {
  num: '4',
  title: 'Mis Primeras Frases',
  subtitle: 'Lecturas simples y progresivas para desarrollar confianza.'
}, {
  num: '5',
  title: 'Mis Primeros Cuentos',
  subtitle: 'Historias cortas para disfrutar la experiencia de leer.'
}];
const includes = ['Actividades imprimibles', 'Ejercicios progresivos', 'Plantillas listas para usar', 'Guías para padres'];
export function FiveVolumes() {
  return <section className="py-12 md:py-16 bg-slate-50" data-id="element-127">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-128">
        <div className="text-center mb-8" data-id="element-129">
          <div className="inline-flex items-center justify-center space-x-2 bg-gold/10 text-gold-700 px-4 py-1.5 rounded-full font-bold text-sm mb-4" data-id="element-130">
            <span data-id="element-131">🏆 COLECCIÓN DIGITAL</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-navy" data-id="element-132">
            MIS PRIMERAS LECTURAS
          </h2>
          <p className="text-lg text-slate-600 font-medium" data-id="element-133">
            5 Tomos + 3 Bonos — Desde las vocales hasta los primeros cuentos.
          </p>
          <p className="text-slate-500 text-sm mt-1" data-id="element-134">
            Todo organizado, secuenciado y listo para imprimir.
          </p>
        </div>

        <div className="space-y-4 mb-10" data-id="element-135">
          {tomos.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-xl p-5 shadow-sm border border-slate-100 flex items-center gap-4" data-id="element-136">
              <div className="w-12 h-12 flex-shrink-0 bg-navy text-white rounded-lg flex flex-col items-center justify-center font-bold" data-id="element-137">
                <span className="text-[10px] opacity-70 leading-none mb-0.5" data-id="element-138">
                  TOMO
                </span>
                <span className="text-xl leading-none" data-id="element-139">{t.num}</span>
              </div>
              <div data-id="element-140">
                <h3 className="font-bold text-navy text-lg" data-id="element-141">{t.title}</h3>
                <p className="text-sm text-slate-600" data-id="element-142">{t.subtitle}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="bg-white rounded-xl p-6 border border-slate-200" data-id="element-143">
          <h4 className="font-bold text-navy mb-4" data-id="element-144">Cada tomo incluye:</h4>
          <ul className="grid md:grid-cols-2 gap-3" data-id="element-145">
            {includes.map((item, i) => <li key={i} className="flex items-start text-sm text-slate-700" data-id="element-146">
                <CheckCircle2 className="w-4 h-4 text-emerald-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-147" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}